import React, { useState, useEffect } from 'react';
import Label from '../../components/label/Label';
import { useSelector, useDispatch } from 'react-redux';
import { encryptData,decryptData } from '../../utils/crypto';
import { getAdminDetails } from '../../actions/userActions';
import { setCookie, getCookie } from '../../utils/cookieHelper';

const TimeComponent = () => {
	const dispatch = useDispatch();

	const [currentTime, setCurrentTime] = useState({ time: '', offset: '' });
	const editProfileLoading = useSelector((state) => state.userEdit.loading);
	const admindetailsGet = useSelector((state) => state.adminDetails);
	const { adminDetails } = admindetailsGet;

	const hasFetched = React.useRef(false);

	useEffect(() => {
	if (!hasFetched.current) {
		dispatch(getAdminDetails());
		hasFetched.current = true;
	}
	}, [dispatch]);

	useEffect(() => {
		if(adminDetails) {
			setCookie({ name: 'timezone', value: encryptData(adminDetails?.time_zone) });
		}
	}, [adminDetails]);

	useEffect(() => {
		// Only update time if the editProfile API is not loading
		if (!editProfileLoading || adminDetails) {
			// Check for the timezone in adminDetails (this could be updated via the profile update)
			const rawTimezone = decryptData(getCookie('timezone'));
			const timezone = rawTimezone ? rawTimezone : '';

			if (!timezone || typeof timezone !== 'string') {
				// console.error('Invalid or missing timezone');
				return;
			}
			const updateTime = () => {
				const now = new Date();
				// Format time in 24-hour format
				const timeOptions = {
					hour: '2-digit',
					minute: '2-digit',
					hour12: false,
					timeZone: timezone,
				};

				const timeFormatter = new Intl.DateTimeFormat(
					'en-US',
					timeOptions
				);
				const formattedTime = timeFormatter.format(now);

				// Get the offset in minutes from UTC for the selected timezone
				const tzDate = new Date(
					now.toLocaleString('en-US', { timeZone: timezone })
				);
				const utcDate = new Date(
					now.toLocaleString('en-US', { timeZone: 'UTC' })
				);

				const offsetMinutes =
					(tzDate.getTime() - utcDate.getTime()) / (1000 * 60);

				// Convert to hours and minutes
				const sign = offsetMinutes >= 0 ? '+' : '−'; // use Unicode minus (−)
				const absOffset = Math.abs(offsetMinutes);
				const hours = Math.floor(absOffset / 60);
				const minutes = absOffset % 60;
				const formattedOffset = `GMT${sign}${hours}:${minutes
					.toString()
					.padStart(2, '0')}`;

				setCurrentTime({
					time: formattedTime,
					offset: formattedOffset,
				});
			};

			// Update time initially and then every second
			updateTime();
			const interval = setInterval(updateTime, 1000);

			// Cleanup interval to avoid memory leaks
			return () => clearInterval(interval);
		}

		// Cleanup when loading is true (to avoid unnecessary intervals during the API call)
		return () => {};
	}, [editProfileLoading, adminDetails]);

	return (
		<li className="time">
			<Label
				type={'primary'}
				fontFamily={'Inter-Regular'}
				fontSize={'xx_inputlabel'}
				label={currentTime.time}
			/>
			<br />
			<Label
				type={'primary'}
				fontFamily={'Inter-Regular'}
				fontSize={'xx_inputlabel'}
				label={currentTime.offset}
			/>
		</li>
	);
};

export default TimeComponent;
